import { gql } from '@apollo/client';

/**
 * Self-service view of a funder's own profile. Fields are listed explicitly
 * rather than pulled from the funder fragment, which also carries programmes,
 * service providers and users that this screen has no business fetching.
 */
export const GET_MY_FUNDER_PROFILE = gql`
  query GetMyFunderProfile($id: ID!) {
    funder(where: { id: $id }) {
      id
      name
      website
      logo
      physicalAddress
      description

      contactPerson
      contactPersonContactNumber
      contactPersonEmail

      organisationLeader
      leaderTitle
      leaderContactNumber
      leaderEmail

      organisationUsersAddOns {
        id
        name
      }
      organisationUsersPlan {
        id
        name
      }
    }
  }
`;
